export default __webpack_public_path__ + "static/media/front.1e344da9.png";